import React, { useState, useEffect, useRef } from "react";

export default function DeferredSection({
  children,
  minHeight = "100vh",
  rootMargin = "400px",
  idleTimeout = 4000,
}) {
  const [shouldRender, setShouldRender] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (shouldRender) return;

    let idleCallbackId;
    let observer;

    if ("IntersectionObserver" in window) {
      observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            setShouldRender(true);
            if (observer) observer.disconnect();
          }
        },
        { rootMargin }
      );
      if (ref.current) {
        observer.observe(ref.current);
      }
    } else {
      setShouldRender(true);
      return;
    }

    // Defer loading during idle time after idleTimeout so scripts preload when network is quiet
    const timeoutId = setTimeout(() => {
      if ("requestIdleCallback" in window) {
        idleCallbackId = window.requestIdleCallback(() => setShouldRender(true));
      } else {
        setShouldRender(true);
      }
    }, idleTimeout);

    return () => {
      if (observer) observer.disconnect();
      clearTimeout(timeoutId);
      if (idleCallbackId && "cancelIdleCallback" in window) {
        window.cancelIdleCallback(idleCallbackId);
      }
    };
  }, [shouldRender, rootMargin, idleTimeout]);

  return (
    <div ref={ref} style={{ minHeight: shouldRender ? "auto" : minHeight }}>
      {shouldRender ? children : null}
    </div>
  );
}
